var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPen = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 16,
  fill: "currentColor"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m12.887 7.559-6.86 6.867a1.6 1.6 0 0 1-.941.446l-2.4.274h-.14a1.207 1.207 0 0 1-1.206-1.333l.273-2.4c.041-.356.2-.687.453-.94l6.86-6.86zM12.357.83a1.57 1.57 0 0 1 1.11.461l1.74 1.74a1.57 1.57 0 0 1 .46 1.11 1.57 1.57 0 0 1-.46 1.11l-1.614 1.613-3.96-3.96 1.613-1.613a1.57 1.57 0 0 1 1.11-.46"
})));
export default SvgPen;